import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.mode === 'dark' ? '#3399bf' : '#576572',
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function TablaDinamico({ rows, header }) {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {header.map(item=>(
                            <StyledTableCell key={item} sx={{ fontWeight: "bold", textTransform: 'uppercase' }} align="left">{item}</StyledTableCell>    
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <StyledTableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <StyledTableCell align="left">{row.tipoAfectacion}</StyledTableCell>
                            <StyledTableCell align="left">{row.descripcion}</StyledTableCell>
                            <StyledTableCell align="left">{row.stock}</StyledTableCell>
                            <StyledTableCell align="left">{row.cantidad}</StyledTableCell>
                            <StyledTableCell align="left">{row.unidadMedida}</StyledTableCell>
                            <StyledTableCell align="left">{row.precioUnitario}</StyledTableCell>
                            <StyledTableCell align="left">{row.descuento}</StyledTableCell>
                            <StyledTableCell align="left">{row.ganancia}</StyledTableCell>
                            <StyledTableCell align="left">{row.IGV}</StyledTableCell>
                            <StyledTableCell align="left">{row.importe}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}